import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';

const TestHeader = ({ testName, status, lastChecked, category }) => {
  // Status icon and color mapping
  const statusConfig = {
    passed: {
      icon: <CheckCircle size={20} className="text-green-500" />,
      text: 'Passed',
      bgColor: 'bg-green-50',
      textColor: 'text-green-700'
    },
    warning: {
      icon: <AlertTriangle size={20} className="text-yellow-500" />,
      text: 'Warning',
      bgColor: 'bg-yellow-50',
      textColor: 'text-yellow-700'
    },
    failed: {
      icon: <XCircle size={20} className="text-red-500" />,
      text: 'Failed',
      bgColor: 'bg-red-50',
      textColor: 'text-red-700'
    }
  };

  // Get status configuration or default to failed
  const currentStatus = statusConfig[status] || statusConfig.failed;

  return (
    <div className="p-4 bg-gray-50 rounded-t-md">
      <h2 className="text-xl font-semibold mb-4">{testName}</h2>
      
      <div className="bg-white p-4 rounded-md shadow-sm">
        <h3 className="text-lg font-medium mb-3">Test Overview</h3>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <p className="text-gray-500 text-sm mb-1">Status</p>
            <div className="flex items-center">
              {currentStatus.icon}
              <span className={`ml-2 font-medium ${currentStatus.textColor}`}>
                {currentStatus.text}
              </span>
            </div>
          </div>
          <div>
            <p className="text-gray-500 text-sm mb-1">Last Checked</p>
            <p className="font-medium">{lastChecked || 'Never'}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm mb-1">Category</p>
            <p className="font-medium">{category}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestHeader;
